import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
class Menu extends Component {
	render() {
		const { children } = this.props;
		return (
			<ul className="main-layout-menu">
				{children.map((child, index) => 
					<li key={index} className="main-layout-menu-item">
						{child}
					</li>
				)}
			</ul>
		);
	}
}
Menu.propTypes = {
	children: PropTypes.node
};

export default Menu;
